<template>
  <div>
    <Transition name="bounce">
      <span v-if="copied" class="text-white fs-10 fw-400">Copied</span>
    </Transition>
    <Icon
      v-if="!copied"
      class="pointer"
      @click="copyValue()"
      :name="name"
      :color="color"
      :size="size"
    />
  </div>
</template>

<script setup lang="ts">
import copyToClipboard from '@/utils/copyToClipboard'
import Icon from '../../components/Icon.vue'
import { ref } from 'vue'

const props = defineProps({
  value: String,
  size: {
    type: Number,
    default: 10,
  },
  color: {
    type: String,
    default: '#95989C',
  },
  name: {
    type: String,
    default: 'copy1',
  },
})
const copied = ref(false)
const copyValue = async () => {
  if (!props.value) return
  await copyToClipboard(props.value)
  copied.value = true
  setTimeout(() => {
    copied.value = false
  }, 2000)
}
</script>

<style scoped>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>
